export const findFixedHeaderOffset = () => {
	const header = document.getElementById('site-header');
	if (!header) return 0;
	return header.getBoundingClientRect().height;
};

export const windowScrollToElement = ({
	targetElement,
	offset = 0,
}: {
	targetElement: HTMLElement;
	offset?: number;
}) => {
	const headerOffset = findFixedHeaderOffset();
	const top = targetElement.getBoundingClientRect().top + window.scrollY - headerOffset - offset;
	window.scrollTo({
		top,
	});
};
